/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterM = createReactComponent("letter-m", "IconLetterM", [
  ["path", { d: "M6 20v-16l6 14l6 -14v16", key: "svg-0" }]
]);

export { IconLetterM as default };
//# sourceMappingURL=IconLetterM.js.map
